import React from "react";
import { useTranslation } from "../../context/LanguageContext";

function UpdatingMessage() {
  const { translate } = useTranslation();
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        background: "#ffffff",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <p style={{ fontSize: 18, lineHeight: 1.5, textAlign: "center", padding: 24 }}>
        {translate("news.updating")}
      </p>
    </div>
  );
}

export default UpdatingMessage;


